import styled from "styled-components";

export const PageContainerDiv = styled.div`
  display: flex;
  flex-direction: column;
  width: 80vw;
  height: 100%;
  min-height: 90vh;
  gap: 5vh;

  align-items: center;
  padding-left: 20vw;
  padding-bottom: 10vh;

  
`;
